export { default } from './PauseHoldsBatchActions';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/PauseHoldsBatchActions/index.js